import React, { useEffect, useRef, useState } from "react";
import "./Login.css";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import reallygreatsit from "../../assets/images/login-bg.png";
import Axios from "../../utils/Axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [otpSent, setOtpSent] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const otpRefs = useRef([]);

  const navigate = useNavigate();

  useEffect(() => {
    let sessionData = localStorage.getItem("SKILL_OP_SESSION");
    sessionData = JSON.parse(sessionData);
    if (sessionData) {
      navigate("/dashboard");
    }
  }, []);

  const sendOtp = async () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    setIsSendingOtp(true);
    try {
      const response = await axios.post(Axios.axiosUrl + Axios.userLogin, {
        EMAIL: email,
        IS_VERIFIED: false,
      });

      if (response.data.OTP_SEND === true) {
        toast.success("OTP sent successfully");
        setOtpSent(true);
      } else {
        toast.error("Failed to send OTP");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleOtpChange = (value, index) => {
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const submitOtp = async () => {
    const finalOtp = otp.join("");
    if (finalOtp.length !== 6 || !/^\d{6}$/.test(finalOtp)) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    setIsVerifyingOtp(true);
    try {
      const response = await axios.post(Axios.axiosUrl + Axios.verifyOtp, {
        EMAIL: email,
        OTP: finalOtp,
      });

      if (response.data.login === true) {
        if (response.data.ROLES === "0") {
          toast.success("Login successful!");
          localStorage.setItem(
            "SKILL_OP_SESSION",
            JSON.stringify(response.data)
          );
          navigate("/dashboard");
        } else {
          toast.error("You are not authorized to access this application");
        }
      } else {
        toast.error("Invalid OTP");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  return (
    <div className="login-container">
      <Toaster position="top-center" />

      <img src={reallygreatsit} className="login-image" alt="Background" />
      <div className="login-box">
        <h2>Login</h2>
        <input
          type="email"
          placeholder="Enter Email ID"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="login-input"
          disabled={otpSent || isSendingOtp || isVerifyingOtp}
        />

        {!otpSent && (
          <button
            onClick={sendOtp}
            className="login-button"
            disabled={isSendingOtp}
          >
            {isSendingOtp ? (
              <>
                <span className="login-loader"></span>Sending...
              </>
            ) : (
              "Send OTP"
            )}
          </button>
        )}

        {otpSent && (
          <>
            <div className="otp-container">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  className="otp-input"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  ref={(el) => (otpRefs.current[index] = el)}
                />
              ))}
            </div>
            <button
              onClick={submitOtp}
              className="login-button"
              disabled={isVerifyingOtp}
            >
              {isVerifyingOtp ? (
                <>
                  <span className="loader"></span>Verifying...
                </>
              ) : (
                "Verify OTP"
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
